import { el, typingTarget } from '../state/store.js';

/* THE X IN THE CORNER, on every popup.

   Each popup's bottom row said leaving in its own words — Close, Cancel, Not
   now, Skip, Back to projects — so there was no one place to look for the way
   out. The X is that place, identical on every card; the bottom buttons stay,
   because several of them say more than "close" (Skip records a refusal,
   Cancel stops an export).

   `onClose` is whatever that popup's own way out already does, so the X can
   never behave differently from the button it sits beside. */
const X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';

export function closeX(card, onClose) {
  card.querySelector(':scope > .xclose')?.remove();
  const b = el('button', 'xclose');
  b.type = 'button';
  b.title = 'Close';
  b.setAttribute('aria-label', 'Close');
  b.innerHTML = X;
  b.onclick = ev => { ev.stopPropagation(); onClose(); };
  card.prepend(b);
  return b;
}

/* Escape presses the X of the popup on top — the last visible overlay in the
   document, since they all share one z-index and stack in DOM order. Not while
   typing: Escape in a field already means "undo what I typed" (renaming a
   project), and a half-filled form should not vanish on it. */
document.addEventListener('keydown', ev => {
  if (ev.key !== 'Escape' || ev.defaultPrevented || typingTarget(ev.target)) return;
  const open = [...document.querySelectorAll('.authwrap')]
    .filter(w => !w.classList.contains('hidden') && w.isConnected && getComputedStyle(w).display !== 'none');
  const x = open[open.length - 1]?.querySelector('.authcard > .xclose');
  if (!x) return;
  ev.preventDefault();
  x.click();
});
